import styled from 'styled-components';

import { NavLink as VersionedNavLink } from 'components/RouterLink';
import { linkStyles } from 'theme';

export const RouterNavLink = styled(VersionedNavLink)`
  ${linkStyles}
`;
